import { useState, useEffect } from 'react';

interface WindowDimensions {
  width: number;
  height: number;
  scrollX: number;
  scrollY: number;
}
const { innerWidth: initialWindowWidth, innerHeight: initialWindowHeight } = window;
const { width: initialScreenWidth, height: initialScreenHeight } = screen;
const initialIsInstagramBrowser = window.navigator.userAgent.match(/instagram/i);
export const useWindowDimensions = (): WindowDimensions => {
  // FIXME: When this is in an SSR context, we need to look at the UA to determine the default return value for this
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>({
    width: initialIsInstagramBrowser ? initialScreenWidth : initialWindowWidth,
    height: initialIsInstagramBrowser ? initialScreenHeight : initialWindowHeight,
    scrollX,
    scrollY,
  });

  useEffect(() => {
    const getWindowDimensions = () => {
      const { scrollX, scrollY, innerWidth: windowWidth, innerHeight: windowHeight } = window;
      const { width: screenWidth, height: screenHeight } = screen;
      const isInstagramBrowser = window.navigator.userAgent.match(/instagram/i);

      return { width: isInstagramBrowser ? screenWidth : windowWidth, height: isInstagramBrowser ? screenHeight : windowHeight, scrollX, scrollY };
    };

    setWindowDimensions(getWindowDimensions());
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
